'use client';
import React, { useEffect, useState } from 'react';
import AppLogo from'@/components/ui/AppLogo';
import Icon from'@/components/ui/AppIcon';
import Link from 'next/link';

const Navigation: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleRequestQuote = () => {
    window.open('https://wa.me/243996739468?text=Hello, I would like to request a quote.', '_blank')
  }

  return (
    <nav
      className={`fixed top-6 left-0 right-0 z-50 flex justify-center px-6 transition-smooth ${
        isScrolled ? 'top-4' : ''
      }`}
    >
      <div
        className={`w-full max-w-5xl flex items-center justify-between px-6 py-4 border border-white/10 rounded-full shadow-2xl transition-smooth hover:shadow-[0_20px_60px_rgba(0,0,0,0.3)] ${
          isScrolled
            ? 'bg-accent/95 backdrop-blur-2xl' :'bg-accent/80 backdrop-blur-xl'
        }`}
      >
        {/* Logo with Enhanced Hover */}
        <Link href="/homepage" className="transition-smooth hover:scale-110">
          <AppLogo text="Mulumbu Minerals" iconName="SparklesIcon" size={64} className="text-white" />
        </Link>

        {/* Navigation Links & Action Button */}
        <div className="flex items-center gap-6">
          <Link
            href="/about"
            className="text-sm font-body font-semibold text-white/80 hover:text-primary transition-smooth hover:scale-105"
          >
            About
          </Link>
          <button
            onClick={handleRequestQuote}
            className="group px-6 py-2 bg-primary text-primary-foreground rounded-full font-body font-semibold text-sm shadow-gold hover:shadow-gold-lg transition-smooth hover:scale-110 hover-glow flex items-center gap-2"
          >
            Request Quote
            <Icon
              name="ArrowRightIcon"
              size={16}
              className="group-hover:translate-x-1 transition-transform"
            />
          </button>
        </div>
      </div>
    </nav>
  )
}

export default Navigation